import React, { useState } from "react";
import supabase from "../services/supabase";
import "../App.css";
import logo from "./IPTalonsLogo.png";

const LabLockLoginPage = () => {
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [isResetMode, setIsResetMode] = useState(false);
  const [resetStatus, setResetStatus] = useState("");

  const handleLogin = async () => {
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email: loginEmail,
        password: loginPassword,
      });
      
      if (error) throw error;

      // Explicitly store the session
      if (data.session) {
        await supabase.auth.setSession(data.session);
      }
    } catch (error) {
      alert('Error logging in: ' + error.message);
    }
  };

  const handlePasswordReset = async () => {
    const { error } = await supabase.auth.resetPasswordForEmail(loginEmail, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    
    if (error) {
      setResetStatus('Error sending reset email: ' + error.message);
    } else {
      setResetStatus('Password reset email sent! Please check your inbox.');
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-container">
        <div className="login-logo-container">
          <img src={logo} alt="IPTalons Logo" className="login-logo" />
        </div>
        <h2 className="login-title">Sign in to LabLock.ai</h2>
        <p style={{ textAlign: 'center', color: '#666', marginBottom: '20px' }}>
          Access your researcher dashboard
        </p>
        <div className="login-form-container">
          <div className="login-form-card">
            <input
              id="email"
              type="email"
              className="login-input"
              placeholder="Email address"
              value={loginEmail}
              onChange={(e) => setLoginEmail(e.target.value)}
            />
            {!isResetMode && (
              <input
                id="password"
                type="password"
                className="login-input"
                placeholder="Password"
                value={loginPassword}
                onChange={(e) => setLoginPassword(e.target.value)}
              />
            )}
          </div>
          {!isResetMode ? (
            <>
              <button className="login-button" onClick={handleLogin}>
                Sign In
              </button>
              <button
                onClick={() => setIsResetMode(true)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#1C6941',
                  marginTop: '15px',
                  cursor: 'pointer',
                  textDecoration: 'underline'
                }}
              >
                Forgot Password?
              </button>
              <div style={{ 
                marginTop: '20px', 
                textAlign: 'center',
                paddingTop: '20px',
                borderTop: '1px solid #eee'
              }}>
                <p style={{ color: '#666', marginBottom: '10px' }}>
                  Don't have an account?
                </p>
                <a
                  href="/signup"
                  style={{
                    color: '#1C6941',
                    textDecoration: 'none',
                    fontWeight: '600'
                  }}
                >
                  Create your researcher account
                </a>
              </div>
            </>
          ) : (
            <>
              <button className="login-button" onClick={handlePasswordReset}>
                Send Reset Link
              </button>
              <button
                onClick={() => setIsResetMode(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#1C6941',
                  marginTop: '15px',
                  cursor: 'pointer'
                }}
              >
                Back to Sign In
              </button>
            </>
          )}
          {resetStatus && (
            <div style={{ marginTop: '15px', textAlign: 'center', color: resetStatus.includes('Error') ? 'red' : 'green' }}>
              {resetStatus}
            </div>
          )}
        </div>
      </div>
      <div className="login-footer">
        &copy; 2025 IPTalons, Inc. All rights reserved.
      </div>
    </div>
  );
};

export default LabLockLoginPage; 